"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var DoctorModule_1 = require("../components/DoctorModule/DoctorModule");
var targetNode = document.querySelector('.doctor-module-section');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(DoctorModule_1.default, null), targetNode);
}
